var AlbumTrackCover      = require("app/ui/covers/AlbumTrackCover"),
    ArtistCover          = require("app/ui/covers/ArtistCover"),
    AudioCover           = require("app/ui/covers/AudioCover"),
    BookCover            = require("app/ui/covers/BookCover"),
    BrandCover           = require("app/ui/covers/BrandCover"),
    CategoryCover        = require("app/ui/covers/CategoryCover"),
    CoverPlaceholder     = require("app/ui/covers/CoverPlaceholder"),
    EpisodeCover         = require("app/ui/covers/EpisodeCover"),
    ExternalCover        = require("app/ui/covers/ExternalCover"),
    IssueCover           = require("app/ui/covers/IssueCover"),
    MagazineCover        = require("app/ui/covers/MagazineCover"),
    MusicAlbumCover      = require("app/ui/covers/MusicAlbumCover"),
    PageCover            = require("app/ui/covers/PageCover"),
    PhotoCover           = require("app/ui/covers/PhotoCover"),
    PlaylistCover        = require("app/ui/covers/PlaylistCover"),
    PodcastCover         = require("app/ui/covers/PodcastCover"),
    PodcastEpisodeCover  = require("app/ui/covers/PodcastEpisodeCover"),
    ProductCategoryCover = require("app/ui/covers/ProductCategoryCover"),
    ProductCover         = require("app/ui/covers/ProductCover"),
    SeriesCover          = require("app/ui/covers/SeriesCover"),
    VideoCover           = require("app/ui/covers/VideoCover"),
    ViewMoreCover        = require("app/ui/covers/ViewMoreCover");

module.exports = function(media) {
    if (!media) {
        return CoverPlaceholder;
    }

    switch (media.type) {
        case "album_track":
            return AlbumTrackCover;
        case "artist_page":
            return ArtistCover;
        case "audio":
            return AudioCover;
        case "book":
            return BookCover;
        case "brand":
            return BrandCover;
        case "category":
            return CategoryCover;
        case "episode":
            return EpisodeCover;
        case "external":
            return ExternalCover;
        case "issue":
            return IssueCover;
        case "magazine":
            return MagazineCover;
        case "music_album":
            return MusicAlbumCover;
        case "page":
            return PageCover;
        case "photo":
            return PhotoCover;
        case "playlist_page":
            return PlaylistCover;
        case "podcast":
            return PodcastCover;
        case "podcast_episode":
            return PodcastEpisodeCover;
        case "product_category":
            return ProductCategoryCover;
        case "product":
            return ProductCover;
        case "series":
            return SeriesCover;
        case "video":
            return VideoCover;
        case "view_more":
            return ViewMoreCover;
        default:
            return CoverPlaceholder;
    }
};
